(function(angular) {
	'use strict';

	/**
	 * Define the HTTP Interceptor
	 */
	var core = angular.module('Core');
	core.factory('HttpInterceptor', function($q, $log, $window, $location, $timeout) {

		// Define http interceptor functions
		var notification = null;
		var loader = null;
		var navigation = null;
		var translate = null;

		var optLockFn = function() {
			navigation.forcePath();
			$timeout(function() {
				$window.location.reload();
			});
		};

		// Show ajax loader
		var showLoader = function() {
			if (loader) {
				loader.show();
			}
		};

		// Hide ajax loader
		var hideLoader = function() {
			if (loader) {
				loader.hide();
			}
		};

		// Handle error
		var error = function(response) {
			hideLoader();

			// Init...
			var status = response.status;
			if (response.data && response.data.httpStatus) {
				status = response.data.httpStatus;
			}


			var data = response.data;
			var message = data ? data.message : '';

			var url = '';
			if (response.config) {
				url = response.config.url;
			}
			if (url) {
				url = url.split('?');
			}

			// Let's see if the error is an ErrorDTO
			if (response.data && response.data.errorType) {
				// More error handling...
				switch (response.data.errorType) {
					case 'ERR_GEN_10': // data not found
					case 'ERR_GEN_30': // data not found
						// Re enable navigation
						navigation.forcePath('/' + status);
						break;
					case 'ERR_GEN_20':
						notification.setOptLockFunction(optLockFn);
						break;
				}
				notification.showApplicationErrorMessage(status, url, response.data);
			} else {
				// Handle by status code
				switch (status) {
					case 0:
						notification.notify('ERROR', translate.instant('error.ajax.status.' + status), null);
						break;
					case 400:
					case 412:
						// TODO VALIDATION ERROR !
						if (response.data.violations) {
							message += '<br /><ul>';
							for (var i = 0; i < response.data.violations.length; i++) {
								message += '<li>' + response.data.violations[i].message + '</li>';
							}
							message += '</ul>';
							notification.notify('ERROR', null, message);
						} else if (message) {
							notification.notify('ERROR', null, message);
						} else {
							var msg = translate.instant('error.ajax.status.' + status);
							notification.showAjaxErrorMessage(status, msg, url);
						}
						break;
					case 401:
						$log.warn('HttpInterceptor: User is unauthorized.');
						break;
					case 403:
					case 404:
						if (!message) {
							message = translate.instant('error.ajax.status.' + status);
						}
						notification.showAjaxErrorMessage(status, message, url);
						// Redirect
						$timeout(function() {
							$location.path('/' + status);
						}, 100);
						break;
					case 407: // Proxy login required
						notification.notify('ERROR', translate.instant('error.ajax.status.407'), null);
						$timeout(function() {
							// redirect to login page
							$window.location = '#/login';
						}, 2000);
						break;
					case 500:
						if (!message) {
							message = translate.instant('error.ajax.status.' + status);
						}
						notification.showAjaxErrorMessage(status, message, url);
						break;
					case 409:
						notification.showOptimisticLock(message);
						break;
					default :
						notification.showAjaxErrorMessage(status, message, url);
				}
			}
		};

		var success = function(response) {
			var _success = true;
			if (response.data && response.data.httpStatus >= 400) {
				// We are in an error case !
				error(response);
				_success = false;
			} else {
				hideLoader();
			}
			return _success;
		};
		return {
			request: function(config) {
				showLoader();
				return config || $q.when(config);
			},
			response: function(response) {
				var ok = success(response);
				if (ok !== false) {
					return response || $q.when(response);
				} else {
					return $q.reject(response);
				}
			},
			responseError: function(rejection) {
				error(rejection);
				return $q.reject(rejection);
			},
			init: function(NotificationService, LoaderService, NavigationService, TranslateService) {
				notification = NotificationService;
				loader = LoaderService;
				navigation = NavigationService;
				translate = TranslateService;
			}
		};
	});
})(angular);
